"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ContainerHolder_1 = __importDefault(require("../Container/ContainerHolder"));
const getInstance = () => ContainerHolder_1.default.getInstance().get("USER_DATE_TIME_CONFIG");
exports.default = {
    setFormats(dateTimeFormat, dateFormat, timeFormat) {
        return getInstance().setFormat(dateTimeFormat, dateFormat, timeFormat);
    },
    getFormats() {
        return getInstance().getFormats();
    },
};
//# sourceMappingURL=dateTimeFormatterConfig.js.map